export default {
    data() {
        return {
            screen: {
                width: 0,
                height: 0
            },
            // //格子视觉大小
            // visionSize: {
            //     w: 16,
            //     h: 16,
            // },
            scaleX: 1, //缩放比例
            scaleY: 1,
            // // 实际 格子大小
            actualSize: {
                w: 16,
                h: 16,
            }
        }
    },
    methods: {
        // _computedActualSize() {
        //     this.actualSize.w = Math.round(this.visionSize.w / this.scaleX);
        //     this.actualSize.h = Math.round(this.visionSize.h / this.scaleY);
        // },
        /**
         * 返回格子大小信息
         */
        getGridPixel() {
            return {
                // visionSize: {
                //     ...visionSize
                // },
                actualSize: {
                    ...actualSize
                }
            }
        },
        /**
         * 返回经过格子调整后的坐标 
         * @param {*} pixel_x 相对于容器的x的坐标
         * @param {*} pixel_y 相对于容器的y的坐标
         */
        getPointByPixel(pixel_x, pixel_y) {
            const {
                w,
                h
            } = this.actualSize;
            const row_x = Math.floor(pixel_x / w);
            const col_y = Math.floor(pixel_y / h);
            return {
                pixel: {
                    x: row_x * w,
                    y: col_y * h
                },
                grid: {
                    row_x: row_x,
                    col_y: col_y
                }
            }

        },
        getDivPositionByPixel(pixel_x, pixel_y, pixel_w, pixel_h) {
            const {
                w,
                h
            } = this.actualSize;
            const row_x = Math.floor(pixel_x / w);
            const col_y = Math.floor(pixel_y / h);

            const row_num = Math.ceil(pixel_w / w);
            const col_num = Math.ceil(pixel_h / h);

            return {
                pixel: {
                    x: row_x * w,
                    y: col_y * h,
                    w: row_num * w,
                    h: row_num * h
                },
                grid: {
                    row_x: row_x,
                    col_y: col_y,
                    row_num,
                    col_num
                }
            }

        },
        getPointByGrid(row_x, col_y) {
            const {
                w,
                h
            } = this.actualSize;
            return {
                pixel: {
                    x: row_x * w,
                    y: col_y * h
                },
                grid: {
                    row_x: row_x,
                    col_y: col_y
                }
            }
        },
        getDivPositionByGrid(row_x, col_y, row_num, col_num) {
            const {
                w,
                h
            } = this.actualSize;
            return {
                pixel: {
                    x: row_x * w,
                    y: col_y * h,
                    w: row_num * w,
                    h: row_num * h
                },
                grid: {
                    row_x: row_x,
                    col_y: col_y,
                    row_num,
                    col_num
                }
            }
        }
    },
}